// © 2023 Amazon Web Services, Inc. or its affiliates. All Rights Reserved.
// This AWS Content is provided subject to the terms of the AWS Customer Agreement available at
// http://aws.amazon.com/agreement or other written agreement between Customer and either
// Amazon Web Services, Inc. or Amazon Web Services EMEA SARL or both.
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Reads ?id=<requestId> from the URL (e.g. from a notification link) and, once the
// matching item shows up in allItems, selects it and invokes onMatch. Runs at most
// once per page load so it doesn't keep re-opening after the user closes the modal.
function useDeepLinkSelection(allItems, actions, onMatch) {
  const location = useLocation();
  const handled = useRef(false);
  const notified = useRef(false);

  useEffect(() => {
    if (handled.current || allItems.length === 0) {
      return;
    }
    const targetId = new URLSearchParams(location.search).get("id");
    if (!targetId) {
      return;
    }

    const match = allItems.find((item) => item.id === targetId);
    if (!match) {
      if (!notified.current) {
        notified.current = true;
        onMatch(null);
      }
      return;
    }

    handled.current = true;
    actions.setSelectedItems([match]);
    onMatch(match);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allItems]);
}

export default useDeepLinkSelection;
